// 验证表单

// 验证非中文英文下划线
const validateActive = (string) => {
  const applyRegExp = /[^a-zA-Z0-9_\u4e00-\u9fa5]+/g;
  return applyRegExp.test(string);
};

// 验证非中文英文小数点
const validateVersion = (string) => {
  const applyRegExp = /[^a-zA-Z0-9/.\u4e00-\u9fa5]+/g;
  return applyRegExp.test(string);
};

export {
  validateActive,
  validateVersion,
};
